export default function ($http) {
    return function () {
        return $http.get('api/vmcaccount/getUniqueVmcAccountNumber')
            .then(result => result.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/services/uniqueReferenceCode.js